<template>
	<input type="text" :value='value' class='my-control form-control' disabled></input>
</template>

<script>
	import {DB} from './../../../constants'
	const FO = 'get_fo.php'
	const HEADER = 'get_header.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'fo',
		data: function () { 
			return {
				value: '',
			}
		},
		props: {
			type: '',
			reg_id: false
		},
		watch: {
			reg_id (id) {
				//console.warn('id = ', id)
				if (typeof id !== 'undefined' && id !== null) {
					fetch(DB + FO + '?id=' + id, {
						credentials: 'include'
					})
					.then(data => data.json())
					.then(data => {
						if (data) {
							this.value = data[0].name
						}
						else {
							this.value = ''
						}
					})
					.catch(err => console.log(err))
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// fo.vue?4775709e